export const mutations = {
  // Ein neu geöffnetes Modal wird auf den Stack der geöffneten Modale gelegt
  OPEN: (state, name) => state.open.unshift(name),
  // Beim Schließen spielt die Position des Modals auf dem Stack keine Rolle
  CLOSE: (state, name) => {
    state.open = state.open.filter((modalName) => modalName !== name);
  },
};
